export default "__VITE_ASSET__iQue4Lkg__"